import React, { useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import styled from 'styled-components'
import 'swiper/css/free-mode'
import OrderList from '../../components/myshopping/OrderList'
import '../../css/myshopping.css'
import '../../css/Order.css'

export default function OrderListInquiry() {
  useEffect(() => {
    // 하단 fixed 버튼이 있으면 푸터 패딩 조정
    const footer = document.querySelector('.footer_wrap') as HTMLElement | null
    if (!footer) return

    footer.style.paddingBottom = isMobile ? '36px' : '0'

    // 언마운트 시 패딩 원복
    return () => {
      footer.style.paddingBottom = ''
    }
  }, [])

  return (
    <>
      <OrderList></OrderList>
    </>
  )
}

export const OrderListInquiryWrap = styled.div`
  padding: 16px 20px 48px 20px;
  /* border-bottom: 8px solid var(--colGray1);  */
  @media screen and (min-width: 768px) {
    padding: 32px 0 120px 0;
    border-bottom: none;
  }
`

export const BenefitWrap = styled.div`
  padding: 24px 0px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media screen and (min-width: 768px) {
    padding: 72px 0;
  }
`

export const PopOrderPassFind = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background: var(--colWhite);
  top: 0;
  left: 0;
  z-index: 30;
`

export const OrdeList = styled.div`
  padding: 0 20px 4px;
  & .order_box {
    padding-bottom: 24px;

    & .order_dateline {
      position: relative;
      width: 100%;
      height: 56px;
      & i {
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 1px;
        background: var(--colGray3);
      }
      & .order_date {
        position: absolute;
        top: 50%;
        left: 50%;
        padding: 0 16px;
        background: var(--colWhite);
        transform: translate(-50%, -50%);
        font-size: 12px;
        line-height: 16px;
        color: var(--colGray7);
      }
    }

    & .order_tit {
      display: flex;
      justify-content: space-between;
      align-items: center;

      & .f_box {
        display: flex;
        align-items: center;
        gap: 8px;
        & strong {
          font-size: 16px;
          line-height: 24px;
          color: var(--colBlack);
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 150px;
        }
        & span {
          font-size: 12px;
          line-height: 16px;
          color: var(--colPointBlue);
          padding: 6px 10px;
          border-radius: 38px;
          background: var(--colLightBlue);
          font-weight: 600;
        }
        & .g_color {
          color: var(--colGray7);
          background: var(--colGray2);
        }
      }

      & button {
        position: relative;
        font-size: 12px;
        line-height: 12px;
        border: 0;
        background: transparent;
        color: var(--colBlack);
        padding: 0 12px 0 0;

        &:after {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          width: 12px;
          height: 12px;
          background: url('../../images/icon_arrow_right.svg') no-repeat;
          background-size: contain;
        }
      }
    }

    & .order_item {
      & .g_color {
        & .img_box {
          position: relative;
          width: 80px;
          height: 80px;
          &:after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0.6);
            border-radius: 10px;
          }
        }
        & p {
          color: var(--colGray5) !important;
        }
      }
    }

    & .order_btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px;
      margin-top: 24px;
      & button {
        width: 100%;
        font-size: 14px;
        line-height: 24px;
        color: var(--colBlack);
        text-align: center;
        padding: 11px 0;
        border: 1px solid var(--colGray3);
        border-radius: 5px;
        background: transparent;
      }
    }
  }
  @media screen and (min-width: 768px) {
    padding: 0;
  }
`
